import type { ReactNode } from "react";

import MetaTags from "@/components/meta-tags";
import { StickySubscribeForm } from "@/components/sticky-subscribe-form";
import { Toaster } from "@/components/ui/sonner";
import { useFlash } from "@/hooks/use-flash";

interface PersistentLayoutProps {
  children: ReactNode;
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash();
  return (
    <>
      <MetaTags />
      {children}
      <StickySubscribeForm />
      <Toaster richColors />
    </>
  );
}
